var $ = jQuery;

function init() {

  const $percentageGraph = $('.percentage-graph');
  const $bars = $percentageGraph.find('.discussion-hero__graph-bar');

  var baseWid;


  if($percentageGraph.length > 0) {
    baseWid = setBaseWidth();
    initGraph();
  }

  function initGraph() {
    $bars.each(function(index) {
      setWidths($(this), index);
    });
  }

  function setWidths($this, i) {
    let barWid = $this.attr('data-total');
    let wid = (barWid/baseWid) * 100;
    let $self = $this;

    setTimeout(function() {
      $self.width( wid +'%');
    }, 200 * i);

  }

  function setBaseWidth($this) {
    let widArray = [];
    $bars.each(function() {
      widArray.push($(this).attr('data-total'));
    });
    return Math.max.apply( Math, widArray );
  }
}

export { init as init };
